import React from 'react';
import Modal from '../../Components/Modal';
import Form, { Actions, Checkboxes, RequiredValidator, Round, Switch } from '../../Components/Form';
import { ulid } from 'ulid';
import { getEntityLink } from '../../Services/helpers';

const ConvertToCustomer = ({quote, refresh, convert, isConverting, setIsConverting, go}) => {

    return <Modal isOpen={isConverting} setIsOpen={setIsConverting} title="Convert to customer" dismissible>
        <Inner {...{quote, convert, refresh, go}} />
    </Modal>
}

const Inner = ({quote, convert, refresh, go}) => {

    const doCovert = async (data) => {
        const customerId = ulid();
        await convert({
            customerId: customerId,
            quoteAction: data.close ? 'close' : 'none', // promise,
            jobsToCreate: data.jobs,
            roundId: data.roundId,
        });
        refresh();
        go(getEntityLink('Customers/Customer', customerId));
    }

    const jobOptions = [
        {value: 'quote', label: 'Quote', help: 'Create a "quote" job for the customer which you can schedule.'},
    ];

    if (quote.estimate) {
        jobOptions.push({
            value: 'estimate',
            label: 'Simple estimate - £' + Math.floor(quote.estimate.lower / 100),
            help: 'Create a job based on the simple estimate.',
        });
    }

    if (quote.itemisations) {
        for (const itemisation of quote.itemisations) {
            jobOptions.push({
                value: itemisation.id,
                label: 'Cost breakdown - £' + Math.floor(itemisation.total / 100),
                help: itemisation.categories.map(cat => cat.name).join(', '),
            });
        }
    }

    return <Form onSubmit={doCovert} closeModalOnSubmit>
        <Checkboxes name="jobs" label="Jobs to create" options={jobOptions} validators={[RequiredValidator]} />
        <Round name="roundId" label="Add jobs to round" />
        <Switch label="Close quote" name="close"/>
        <Actions submit={{label: 'Convert to customer', theme: 'danger'}} cancel />
    </Form>;
}

export default ConvertToCustomer;
